/**
 * Internal dependencies
 */
import cecSdk from 'lib/customer-ec-sdk';
import * as actions from 'state/action-types';

export default (paymentTypeId = null) => (dispatch) => {
    return cecSdk
        .connectionPaymentTypes(paymentTypeId)
        .remove()
        .then(() => {
            dispatch({ type: actions.DELETE_CONNECTION_PAYMENT_TYPES_SUCCESS, payload: { paymentTypeId } });
        });
};
